export const SSO_PROVIDERS = {
  MICROSOFT: 'microsoft',
  GOOGLE: 'google',
} as const;
